module.exports = __webpack_public_path__ + "img/forbes-foo.7e3a0749.svg";